module.exports = __webpack_public_path__ + "img/KGtoggleoff.f7335475.png";